import { render, staticRenderFns } from "./ProductClasses.vue?vue&type=template&id=87a507de&scoped=true"
import script from "./ProductClasses.vue?vue&type=script&lang=js"
export * from "./ProductClasses.vue?vue&type=script&lang=js"
import style0 from "./ProductClasses.vue?vue&type=style&index=0&id=87a507de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a507de",
  null
  
)

export default component.exports